import { render, staticRenderFns } from "./CreateContentTemplateDialogHub.vue?vue&type=template&id=0f23198c"
import script from "./CreateContentTemplateDialogHub.vue?vue&type=script&lang=js"
export * from "./CreateContentTemplateDialogHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports